module.exports = __webpack_public_path__ + "img/icon-circle-line-white.ea057832.svg";